// 文章主题配置
export const topics = [
  {
    id: "tech",
    name: "技术积累",
    slug: "tech",
    description: "闷声大发财",
    icon: "💻",
    color: {
      primary: "#3b82f6",
      secondary: "#1e40af",
      gradient: "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)",
    },
    image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800",
  },
  {
    id: "ai",
    name: "AI相关",
    slug: "ai",
    description: '"但AI不会抢工作"',
    icon: "🤖",
    color: {
      primary: "#10b981",
      secondary: "#059669",
      gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    },
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800",
  },
  {
    id: "jottings",
    name: "省流模式",
    slug: "jottings",
    description: "懒得写太长的",
    icon: "✍️",
    color: {
      primary: "#f59e0b",
      secondary: "#d97706",
      gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
    },
    image: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=800",
  },
  {
    id: "other",
    name: "其他",
    slug: "other",
    description: "这些都啥啊",
    icon: "🗂️",
    color: {
      primary: "#6b7280",
      secondary: "#4b5563",
      gradient: "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)",
    },
    image: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800",
  },
];

// 根据 slug 获取主题
export function getTopicBySlug(slug) {
  return (
    topics.find((topic) => topic.slug === slug) ||
    topics.find((topic) => topic.id === "other")
  );
}

// 根据 id 获取主题
export function getTopicById(id) {
  return (
    topics.find((topic) => topic.id === id) ||
    topics.find((topic) => topic.id === "other")
  );
}

// 获取所有主题
export function getAllTopics() {
  return topics;
}
